import React, { useEffect, useRef } from "react";

type Props = {
  node?: any;
};

// Extend the Window interface to include Twitter widgets
declare global {
  interface Window {
    twttr?: {
      widgets?: {
        load: (element?: HTMLElement) => void;
      };
    };
  }
}

function Tweet({ node }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Re-initialize Twitter widgets after component mounts
    // This is necessary when navigating via frontend routing
    if (
      typeof window !== "undefined" &&
      window.twttr &&
      window.twttr.widgets &&
      containerRef.current
    ) {
      // Pass the container element to load only tweets within this component
      window.twttr.widgets.load(containerRef.current);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="block my-8 sm:my-16 rounded-lg overflow-hidden isolate mx-auto"
      dangerouslySetInnerHTML={{ __html: node.code }}
    />
  );
}

export default Tweet;
